jQuery(document).ready(function ($) {

  //ABRIR MENU MOBILE
  $('.abrir-menu-container, .menu-mobile .botao-fechar').click(function (e) {
    e.preventDefault();
    if (!$('.menu-mobile').hasClass('menu-site-aberto')) {
      abreMenu();
    } else {
      fechaMenu();
    }
  });
  $('.menu-overlay').click(function (e) {
    e.preventDefault();
    if (!$('.menu-overlay').hasClass('menu-overlay-aberto')) {
      abreMenu();
    } else {
      fechaMenu();
    }
  });

  function abreMenu() {
    $('.menu-mobile').addClass('menu-site-aberto');
    $('.menu-overlay').addClass('menu-overlay-aberto');
  }

  function fechaMenu() {
    $('.menu-mobile').removeClass('menu-site-aberto');
    $('.menu-overlay').removeClass('menu-overlay-aberto');
  }

  //BALAO DO WHATS
  $('a.whats').click(function (e) {
    closeWhatsBallon();
  });

  $('.whats-balao').hover(function (e) {
    closeWhatsBallon();
  });

  function closeWhatsBallon() {
    $('.whats-balao').remove();
  }

  setTimeout(function () {
    closeWhatsBallon();
  }, 10000);

  //GALERIA
  $('.galeria-page a, a.galeria-campo').magnificPopup({
    type: 'image',
    gallery: {
      enabled: true,
      tPrev: 'Anterior',
      tNext: 'Próxima',
      tCounter: '%curr% de %total%'
    }
  });

  //POPOVER DE INFORMACAO DA INSTITUICAO

  jQuery(function ($) {
    const seletor = '[data-prm-popover]';
    const $botoes = $(seletor);

    if (!$.fn.popover) {
      return;
    }

    $botoes.popover({
      container: 'body',
      placement: 'auto',
      trigger: 'click',
      html: true,
      animation: false,
      template:
        '<div class="popover prm-instituicao-popover" role="tooltip">' +
        '<div class="arrow"></div>' +
        '<h3 class="popover-header"></h3>' +
        '<div class="popover-body"></div>' +
        '</div>'
    });

    // Mantém somente um popover aberto.
    $botoes.on('show.bs.popover', function () {
      $botoes.not(this).popover('hide');
    });

    $botoes.on('shown.bs.popover', function () {
      $(this).attr('aria-expanded', 'true');
    });

    $botoes.on('hidden.bs.popover', function () {
      $(this).attr('aria-expanded', 'false');
    });

    // Fecha ao clicar fora, preservando cliques nos links internos.
    $(document).on('click.prmPopover', function (evento) {
      if (!$(evento.target).closest(
        seletor + ', .prm-instituicao-popover'
      ).length) {
        $botoes.popover('hide');
      }
    });

    // Escape fecha e devolve o foco ao botão.
    $(document).on('keydown.prmPopover', function (evento) {
      if (evento.key === 'Escape') {
        const $aberto = $botoes.filter('[aria-expanded="true"]');

        if ($aberto.length) {
          $aberto.popover('hide');
          $aberto.first().trigger('focus');
        }
      }
    });

    // Permite acessar o link do popover pelo teclado.
    $botoes.on('keydown', function (evento) {
      if (
        evento.key !== 'Tab' ||
        evento.shiftKey ||
        $(this).attr('aria-expanded') !== 'true'
      ) {
        return;
      }

      const popoverId = this.getAttribute('aria-describedby');
      const popover = document.getElementById(popoverId);
      const link = popover && popover.querySelector('a[href]');

      if (link) {
        evento.preventDefault();
        link.focus();
      }
    });

    // Ao sair do link com Tab, retorna ao botão e fecha o popover.
    $(document).on(
      'keydown.prmPopover',
      '.prm-instituicao-popover a',
      function (evento) {
        if (evento.key !== 'Tab') {
          return;
        }

        const $aberto = $botoes.filter('[aria-expanded="true"]');

        if ($aberto.length) {
          evento.preventDefault();
          $aberto.popover('hide');
          $aberto.first().trigger('focus');
        }
      }
    );
  });

  //CARROSSEIS
  $('.instituicoes-carrosel').owlCarousel({
    loop: false,
    margin: 10,
    autoplay: true,
    autoplayTimeout: 5000,
    dots: false,
    lazyLoad: true,
    navText: ["&#8592;", "&#8594;"],
    nav: true,
    autoHeight: true,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      1000: {
        items: 4
      }
    }
  });

  $('.programas-carrosel').owlCarousel({
    loop: false,
    margin: 30,
    autoplay: true,
    autoplayTimeout: 5000,
    dots: false,
    lazyLoad: true,
    navText: ["&#8592;", "&#8594;"],
    nav: true,
    autoHeight: false,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 2
      },
      1000: {
        items: 4
      }
    }
  });

  //FIX HEADER
  window.onscroll = function () {
    fixHeader()
  };

  function fixHeader() {
    if (window.pageYOffset > 70) {
      $('#topo').addClass('scrooled');
    } else {
      $('#topo').removeClass('scrooled');
    }
  }

  //PIZZA BUILDER
  $('body.single p.price').addClass('d-none');
  const preco = $('p.price span.woocommerce-Price-amount bdi').html();

  if (preco) {
    if (preco.slice(-6) === '360,00') {
      $('button.single_add_to_cart_button.button.alt').prop('disabled', true);
    }

    var target = document.getElementsByClassName('price')[0];

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {

          if (target.innerText != preco) {
            $('button.single_add_to_cart_button.button.alt').prop('disabled', false);
            $('p.price').removeClass('d-none');
          }

          if (target.innerText.slice(-6) === '360,00') {
            $('button.single_add_to_cart_button.button.alt').prop('disabled', true);
            $('p.price').addClass('d-none');
          }

        }
      });
    });

    var config = {characterData: true, childList: true, subtree: true};

    observer.observe(target, config);

    $('.component-item .component-img .component-buttons .pizza-quantity button.qty_button.qty_button_plus').click(function () {
      $(this).addClass('d-none');
      $(this).parent().parent().parent().addClass('ativo');
    });

    $('.component-item .component-img .component-buttons .pizza-quantity button.qty_button.qty_button_minus').click(function () {
      $(this).parent().find('button.qty_button.qty_button_plus').removeClass('d-none');
      $(this).parent().parent().parent().removeClass('ativo');
    });

  }

  if (performance.navigation.type == 2 && _PAG_PRODUTO) {
    location.reload(true);
  }

  //CHECKOUT

  //REMOVER O PONTO DO CARRINHO
  $('.texto_solicitacao_ponto').each(function () {
    this.innerHTML += ' <a href="' + myThemeParams._PG_PONTO + '" target="_blank">Clique para acessar o regulamento e o formulário.</a>';
  });

  $('.texto_solicitacao_atendimento').each(function () {
    this.innerHTML += ' <a href="' + myThemeParams._PG_ATENDIMENTO + '" target="_blank">Clique para acessar o regulamento e o formulário.</a>';
  });

  $('.texto_solicitacao_isencao').each(function () {
    this.innerHTML += ' <a href="' + myThemeParams._PG_ISENCAO + '" target="_blank">Clique para acessar o regulamento e o formulário.</a>';
  });


});